import { useState } from "react";
import { Link, useLocation } from "wouter";
import { Boton, Dialogo } from "@/components/ui";
import { useToast } from "@/components/ui/Toast";
import { useDatos } from "../store/store";
import { useDatosApi } from "../DatosContext";
import { gateMinimo, validarParaGuardar, type Problema } from "../progreso";
import { cargarMotor } from "../useFotoEnVivo";
import { seccion } from "../secciones";

const liga = (p: Problema) => `/datos/${p.seccion}${p.ancla ? `#${p.ancla}` : ""}`;

/** "Guardar como mi foto de hoy": revisa lo mínimo, muestra avisos y guarda (source = form). */
export function GuardarFoto({ className, tamano = "md" }: { className?: string; tamano?: "md" | "lg" }) {
  const inputs = useDatos((s) => s.inputs);
  const api = useDatosApi();
  const toast = useToast();
  const [, navegar] = useLocation();
  const [revision, setRevision] = useState<{ bloqueos: Problema[]; avisos: Problema[] } | null>(null);
  const [guardando, setGuardando] = useState(false);
  const faltan = gateMinimo(inputs);

  async function revisar() {
    const compute = await cargarMotor();
    const r = validarParaGuardar(inputs, compute(inputs));
    if (r.bloqueos.length || r.avisos.length) setRevision(r); else await guardar();
  }
  async function guardar() {
    setGuardando(true);
    const err = await api.guardarFoto();
    setGuardando(false);
    if (err) { toast.error(err); return; }
    setRevision(null);
    toast.ok("Tu foto quedó guardada.");
    navegar("/foto");
  }
  return (
    <>
      <Boton className={className} tamano={tamano} cargando={guardando} disabled={api.modo === "demo"} onClick={() => void revisar()}
        title={faltan.length ? `Falta: ${faltan.map((f) => f.texto).join(", ")}` : undefined}>Guardar como mi foto de hoy</Boton>
      {faltan.length > 0 && api.modo === "real" && <p className="mt-1 text-xs text-tinta-suave">Para guardar falta: {faltan.map((f) => f.texto).join(", ")}.</p>}
      <Dialogo abierto={!!revision} onCerrar={() => setRevision(null)} titulo={revision?.bloqueos.length ? "Antes de guardar, falta esto" : "Antes de guardar, revisa"}>
        {revision && (
          <div className="flex flex-col gap-4 text-sm">
            {revision.bloqueos.length > 0 && (
              <ul className="flex flex-col gap-2">{revision.bloqueos.map((p, i) => <li key={i}><Link href={liga(p)} onClick={() => setRevision(null)} className="font-medium text-primary underline">{seccion(p.seccion)?.titulo}</Link>: {p.texto}</li>)}</ul>
            )}
            {revision.avisos.length > 0 && (
              <ul className="flex flex-col gap-2 text-tinta-suave">{revision.avisos.slice(0, 8).map((p, i) => <li key={i}>{p.texto} <Link href={liga(p)} onClick={() => setRevision(null)} className="text-primary underline">Corregir</Link></li>)}</ul>
            )}
            <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
              <Boton variante="secundario" onClick={() => setRevision(null)}>Seguir llenando</Boton>
              {revision.bloqueos.length === 0 && <Boton cargando={guardando} onClick={() => void guardar()}>Guardar igual</Boton>}
            </div>
          </div>
        )}
      </Dialogo>
    </>
  );
}
